import _isObject from 'lodash.isobject';

export function isObject(value: any) {
  return _isObject(value);
}
